import { WorkflowNode } from '@ply-io/ply-front-shared-utilities';

import { editNode } from '@/store/modules/selectedNode/getters';
import { useStore } from '@/utils/store';

export const useSelectedNodeGetters = () => {
	const { getter } = useStore();
	return {
		editNode: getter<WorkflowNode | undefined>(editNode),
	};
};
